import { ChangeEvent } from "react";
import { Meeting } from "./components/MeetingComponent"; 

export enum Options {
  DEACTIVATED = "DEACTIVATED",
  MANDATORY = "MANDATORY",
  OPTIONAL = "OPTIONAL",
}
export interface Notification{
  description: string;
  idNotification: number;
  idNotificationNode: number;
  active: number;
  status: Options;
  type: string;
}
export interface ContentData {
  id?: number;
  title: string;
  shortTitle: string;
  label: string;
  description: string;
  image: null | string;
  originalNodeCode: any;
  company: {
    id: string;
  };
  nodeLevel: number;
  idNode?: string
  status: StatusTypes;
  nodeCode?: string;
  parentNodeCode: string;
  parentNodes?:any;
  availableToImport?: boolean;
  essential: boolean;
  validity?: number;
  visibility?: number;
  entryPoint: any;
  modality: string;
  selfEnrollment: boolean;
  author: string;
  authorEmail: string;
  tags: string[];
  idCertificate: string | null;
  meetings: any[];
  attendanceListAsApprovalCriteria: number;
  enableCertificateForChildren: boolean,
  hasEnrollmentStarted: boolean,
  hasImpactEvaluation: number,
  hasChildren: boolean
  nodeType?: string
  syllabus?: string
  notifications?: Notification[]
  hasEnrollmentCompleted?: boolean,
  idImpactEvaluation?: number
  workload?:string,
  sideMenu?: number
  
}

export enum StatusTypes {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
  ARCHIVED = "ARCHIVED",
}

export interface ParamsHandle {
  event: ChangeEvent<HTMLInputElement>;
  data: {
    [key: string]: number | string | null
  };
}

export enum nodeType {
  ORGANIZATION = "ORGANIZATION",
  LEARNING = "LEARNING",
}

export type NodeParametersProps = {
  editPropsNodes: (payload: {
    [key: string]: number | string | string[] | Meeting[] | boolean | null;
  }) => void;
  nodeCode: string;
  editNodeCode: boolean;
  setNodeData: any;
  setLoadingNodeList: any;
  permissionLeraningPage: boolean;
};


export const fallbackMessage = {
  title: "Ocorreu uma falha ao carregar o conteúdo!",
  message:
    "Aguarde alguns minutos e tente novamente, mas caso o problema persista, entre em contato com o suporte.",
};

export const notFoundMessage = {
  title: "Conteúdo não encontrado!",
  message: "Provavelmente este conteúdo foi removido.",
};
